export const matchesFilters = (
  customer: { name: string; country?: string | null },
  filters: { search: string; countries: string[] }
): boolean => {
  const searchTerm = filters.search.toLowerCase()
  const selectedCountries = filters.countries

  const nameMatchesSearch = customer.name.toLowerCase().includes(searchTerm)

  const countryFilterIsEmpty = selectedCountries.length === 0
  const customerCountryIsSelected =
    customer.country != null && selectedCountries.includes(customer.country)

  const countryMatchesFilter = countryFilterIsEmpty || customerCountryIsSelected

  return nameMatchesSearch && countryMatchesFilter
}
